
import React, { FC } from 'react';

import Button from '../../components/Button';
import translate from '../../translate';
import EmailEditorBlock from './EmailEditorBlock';

export interface ActionsVersionProps {
    disableEdit: boolean;
    newEmailTemplate?: any;
    activateVersion: any;
    data: any;
    saveVersion: any;
    deleteVersion: any;
    testVersion: any;
    changeVersionValue: any;
}

const ActionsVersion: FC<ActionsVersionProps> = (props) => {
    if (props.disableEdit || props.newEmailTemplate) {
        return null;
    }

    return (
        <div style={{display: "flex", columnGap: "5px", justifyContent: "left"}}>
            <Button color="primary" variant="contained" onClick={() => props.saveVersion(true)}>
                {translate('emailTemplateDetail.createEmailTemplateVersion')}
            </Button>
            <Button color="primary" variant="contained" onClick={() => props.saveVersion()}>
                {translate('emailTemplateDetail.saveEmailTemplateVersion')}
            </Button>
            <Button
                color="primary"
                variant="contained"
                onClick={() => props.activateVersion()}
                disabled={!!props.data.active}
            >
                {translate('emailTemplateDetail.activateEmailTemplateVersion')}
            </Button>
            <Button color="primary" variant="contained" onClick={() => props.deleteVersion()}>
                {translate('emailTemplateDetail.deleteEmailTemplateVersion')}
            </Button>
            <Button color="primary" variant="contained" onClick={() => props.testVersion()}>
                {translate('emailTemplateDetail.testEmailTemplateVersion')}
            </Button>
            <EmailEditorBlock data={props.data} changeValue={props.changeVersionValue} />
        </div>
    );
};

export default ActionsVersion;
